export default [{
  header: 'Gestión de contratos',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: '/contratos/panel',
      name: 'Panel',
      icon: 'GridIcon',
      slug: 'panel',
      permiso: 'WB000'
    }
  ]
}];
